module.exports = __webpack_public_path__ + "static/img/logo.14b8576.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/logo.png
// module id = 3kNX
// module chunks = 1